// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"554":"8beaab94","799":"503948b7","826":"e6932ee8","906":"6d9f7541"}[chunkId] + ".css";
};